import React, { useEffect, useState } from "react";
import API_BASE_URL from "../api";
import SEO from "../components/SEO";

const Results = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/results`)
      .then((res) => res.json())
      .then((data) => {
        setResults(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching results:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    
    <><SEO
      title="Latest Sarkari Results 2026"
      description="Check Latest Sarkari Results and Merit Lists."
      keywords="results, sarkari result, government exam result"
      url="https://sarkaricareerinfo.com/results" />
      
      <div className="results-page">
        <h1>All Results</h1>
        <div className="results-grid">
          {results.map((result) => (
            <div key={result.id} className="result-card">
              <h3>{result.exam_name}</h3>
              <p><strong>Job Post:</strong> {result.job_post}</p>
              <p><strong>Department:</strong> {result.department}</p>
              <p><strong>Result Date:</strong> {result.result_date}</p>
              <p><strong>Status:</strong> {result.result_status}</p>

              {result.merit_list_link && (
                <a href={result.merit_list_link} target="_blank" rel="noopener noreferrer">
                  📋 Merit List
                </a>
              )}

              {result.score_card_link && (
                <a href={result.score_card_link} target="_blank" rel="noopener noreferrer">
                  📊 Score Card
                </a>
              )}

              {result.official_notice_link && (
                <a href={result.official_notice_link} target="_blank" rel="noopener noreferrer">
                  📄 Official Notice
                </a>
              )}
            </div>
          ))}
        </div>
      </div></>
  );
};

export default Results;